import { baseTheme } from '@src/theme';
import { Card } from 'antd';
import styled, { css } from 'styled-components';

interface StyledCardProps {
    fullWidth?: boolean;
    isInnerCard?: boolean;
    headerBgColor?: string;
}

export const StyledCard = styled(Card)<StyledCardProps>`
    ${(props) =>
        props.fullWidth &&
        css`
            width: 100% !important;
            max-width: 100%;
        `}

    ${(props) =>
        props.isInnerCard &&
        css`
            border: 1px solid
                ${(p) =>
                    p.theme?.colors?.secondary?.light?.border ||
                    baseTheme.colors.secondary.light.border};
        `}

  &.ant-card {
        border-radius: 8px;

        .ant-card-head {
            padding: 0 16px;
            min-height: 48px;
            border-bottom: none;
            border-radius: 0 0 8px 8px;
            ${(props) =>
                props.headerBgColor &&
                css`
                    background-color: ${props.headerBgColor};
                `}

            .ant-card-head-wrapper {
                ${(props) =>
                    props.extra &&
                    css`
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        gap: 1rem;
                    `}
            }

            .ant-card-head-title {
                font-weight: 500;

                .card-title-with-icon {
                    display: flex;
                    align-items: center;

                    .card-title-icon {
                        display: flex;
                        align-items: center;
                    }

                    span + span {
                        margin-left: 8px;
                    }
                }
            }
        }

        &.ant-card-small {
            .ant-card-head {
                min-height: 36px;
            }
        }

        &.ant-card-hoverable:hover {
            box-shadow: 0 4px 12px
                ${(props) =>
                    props.theme?.colors?.secondary?.light?.surfaceBg ||
                    baseTheme.colors.secondary.light.surfaceBg};
        }
    }
`;
